let productSlider = null;
let quickShopSlider = null;

window.addEventListener('load', (event) => {
  updateTopinRoot();
});
window.addEventListener('resize', (event) => {
  updateTopinRoot();
});

function updateTopinRoot(){
  let headerEle = document.querySelector('.site-header');
  if(headerEle != undefined){
    let headerHeight = headerEle.clientHeight;
    document.querySelector(':root').style.setProperty('--bs-navdrawer',`${headerHeight}px`);
  }

  let topbarEle = document.querySelector('.topbar');
  if(topbarEle != undefined){
    let topbarHeight = topbarEle.clientHeight;
    document.documentElement.style.setProperty('--bs-topbar-height',`${topbarHeight}px`);
  }

  let detch = document.querySelector('mobile-nav');
  if (detch !== null && detch !== undefined) {
    document.querySelector('body').appendChild(detch);
  }
}
/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 class Dropdown {
  constructor(element) {
    this.element = element;
    this.dropdownParent = element.parentElement;
    this.supportedEvents = ["focusin", "click", "mouseout", "touchstart"];
    this.isHandlingClick = false;
    this.isMouseDown = false;
    this.init();
  }

  init() {
    this.element.addEventListener('mousedown', () => {
      this.isMouseDown = true;
      document.addEventListener('mouseup', () => {
        this.isMouseDown = false;
      }, { once: true });
    });

    this.supportedEvents.forEach((type) => {
      if (type === 'click') {
        this.element.addEventListener(type, (evt) => {
          // Prevent double-click issues
          if (this.isHandlingClick) {
            return;
          }
          
          this.isHandlingClick = true;
          
          // Prevent default link behavior
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();
          
          // Open/close menu on single click
          let isActive = this.dropdownParent.classList.contains('open');
          if (!isActive) {
            this.dropdownShow(this.dropdownParent);
          } else {
            this.dropdownHide(this.dropdownParent);
          }
          
          // Reset flag after a short delay
          setTimeout(() => {
            this.isHandlingClick = false;
          }, 300);
        }, true); // Use capture phase to catch click earlier
      } else if (type === 'mouseout' || type === 'touchstart') {
        this.dropdownParent.addEventListener(type, (evt) => {
          let mobileContainer = evt.currentTarget.closest('[data-touch-moveable]');
          if (!mobileContainer) {
            // Only close on mouseout if we're actually leaving (not just moving within)
            // Don't close if mouse is still over the menu item or dropdown content
            if (!this.element.contains(evt.relatedTarget) && 
                !this.dropdownParent.contains(evt.relatedTarget)) {
              this.dropdownHide(this.dropdownParent, evt.type);
            }
          }
        }, true);
      } else if (type === 'focusin') {
        // Handle keyboard navigation
        this.dropdownParent.addEventListener(type, (evt) => {
          let mobileContainer = evt.currentTarget.closest('[data-touch-moveable]');
          if (mobileContainer) return;

          // Open on focus for keyboard navigation
          if (!this.dropdownParent.classList.contains('open') && !this.isMouseDown) {
            this.dropdownShow(this.dropdownParent);
          }
        });

        this.dropdownParent.addEventListener('focusout', (evt) => {
          let mobileContainer = evt.currentTarget.closest('[data-touch-moveable]');
          if (mobileContainer) return;

          // Check if the new focus target is still within the dropdown
          if (this.dropdownParent.contains(evt.relatedTarget)) return;

          // Close on focusout for keyboard navigation
          if (this.dropdownParent.classList.contains('open')) {
            this.dropdownHide(this.dropdownParent);
          }
        });

        this.element.addEventListener(type, (_evt) => {
          this.childOnFocusChange(this.dropdownParent);
        });
      }
    });

    // Keep menu open when hovering over the menu item itself
    // Only close other menus when hovering on a different dropdown menu item
    this.element.addEventListener('mouseenter', (evt) => {
      let mobileContainer = evt.currentTarget.closest('[data-touch-moveable]');
      if (mobileContainer) return;
      
      // Don't interfere if we just clicked
      if (this.isHandlingClick) return;
      
      // Close other open dropdown menus when hovering on a different menu item
      // But keep this menu open if it's already open
      let openDropdowns = Array.from(this.dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
      openDropdowns.forEach((ele) => {
        // Don't close this menu, only close others
        if (ele !== this.dropdownParent) {
          ele.classList.remove('open');
          if (ele.querySelector('[is="drop-down"]')) {
            ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
          }
        }
      });
    });

    // Keep menu open when hovering over the dropdown content
    this.dropdownParent.addEventListener('mouseenter', (evt) => {
      let mobileContainer = evt.currentTarget.closest('[data-touch-moveable]');
      if (mobileContainer) return;
      // Menu stays open when hovering over it
    });

    // Close menu only when mouse leaves the entire dropdown area (both menu item and content)
    this.dropdownParent.addEventListener('mouseleave', (evt) => {
      let mobileContainer = evt.currentTarget.closest('[data-touch-moveable]');
      if (mobileContainer) return;
      
      // Only close if we're actually leaving the entire dropdown (not moving to a child element)
      // Check if we're leaving both the dropdownParent and the element
      let isLeavingDropdown = !this.dropdownParent.contains(evt.relatedTarget);
      let isLeavingElement = !this.element.contains(evt.relatedTarget);
      
      if (isLeavingDropdown && isLeavingElement) {
        // Close this menu when leaving entirely
        if (this.dropdownParent.classList.contains('open')) {
          this.dropdownHide(this.dropdownParent);
        }
      }
    });

    this.bindEvents();
  }

  bindEvents(){
    let closeBtn = this.dropdownParent.querySelector('.close-submenu');
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        let parentElement = evt.currentTarget.closest('.dropdown');
        if (parentElement) this.dropdownToggle(parentElement);
      });
    }
  }

  handleDropdownEvent(evt) {
    /* let currentTarget = evt.currentTarget;
    let liveTarget = evt.target;
    if (liveTarget.classList.contains('nav-link-title')) {
      let linkHref = currentTarget.getAttribute('data-href');
      if (linkHref) window.location.href = linkHref;
    } else {*/
      // For clicks, toggle immediately without delay
      if (evt.type === 'click') {
        let isActive = this.dropdownParent.classList.contains('open');
        if (!isActive) {
          this.dropdownShow(this.dropdownParent);
        } else {
          this.dropdownHide(this.dropdownParent);
        }
      } else {
        this.dropdownToggle(this.dropdownParent);
      }
    /* } */
  }

  dropdownToggle(dropdownParent) {
    // setTimeout(() => {
    //   dropdownParent.classList.contains('open')
    //     ? this.dropdownHide(dropdownParent)
    //     : this.dropdownShow(dropdownParent);
    // }, 50);
    let isActive = dropdownParent.classList.contains('open');

    // Capture context if `this` is used for methods like `dropdownShow` and `dropdownHide`
    const self = this;
    
    setTimeout(function() {
      // Check if the dropdown is not active
      if (!isActive) { 
        if (dropdownParent.classList.contains('second-level')) {
          document.querySelector('#mobile-menu-drawer').classList.add('secondD__active');
        } else if (dropdownParent.classList.contains('third-level')) {
          document.querySelector('#mobile-menu-drawer').classList.add('thirdD__active');
        }
    
        // Call the dropdownShow method with the proper context
        self.dropdownShow(dropdownParent);
      } 
      // Check if the dropdown is active
      else {
        if (dropdownParent.classList.contains('second-level')) {
          document.querySelector('#mobile-menu-drawer').classList.remove('secondD__active');
        } else if (dropdownParent.classList.contains('third-level')) {
          document.querySelector('#mobile-menu-drawer').classList.remove('thirdD__active');
        }
    
        // Call the dropdownHide method with the proper context
        self.dropdownHide(dropdownParent);
      }
    }, 50);
    
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }
  
    this.element.setAttribute('aria-expanded', true);
    if (!dropdownParent.closest('[data-role="drawer"]')) {
     
      
      dropdownParent.classList.add('open');
    } else {
   
      
      Utility.toggleElement(dropdownParent, 'open');
    }
  }

  dropdownHide(dropdownParent, eventType) {
    if (!dropdownParent) {
      return;
    }
   
    this.element.setAttribute('aria-expanded', false);
    if (!dropdownParent.closest('[data-role="drawer"]')) {
      dropdownParent.classList.remove('open');
    } else {
      Utility.toggleElement(dropdownParent, 'close');
    }

    if (eventType === 'mouseout' && dropdownParent.parentElement.closest('.dropdown')) {
      dropdownParent.parentElement.closest('.dropdown').classList.remove('open');
    }

    let childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        if (child.querySelector('a[data-toggle="open"]'))
          child.querySelector('a[data-toggle="open"]').setAttribute('aria-expanded', false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    let currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      let eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }
}
const allDropdowns = document.querySelectorAll('a[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
 * Close SubMenu Dropdowns on Regular Nav Item fous or click
 *
 * @param {element} element - Dropdown element
 */
 class DefaultNavItem {
  constructor(element) {
    this.element = element;
    this.supportedEvents = ["focusin", "click", "mouseout", "touchstart"];
    this.init();
  }

  init() {
    let _this = this.element;
    this.supportedEvents.forEach((type) => {
      _this.addEventListener(type, (e) => {
        e.stopPropagation();
        let currentTarget = e.currentTarget;
        if (!currentTarget.closest('[data-touch-moveable]')) {
          // Only close dropdowns on click, not on hover
          if (type === 'click') {
            this.hideDropdown(currentTarget.parentElement);
          }
        }
      });
    });

    _this.addEventListener('touchend', (e) => {
      e.stopPropagation();
    });
  }

  hideDropdown(dropdownParent) {
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
      ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
    });
  }
}
const allDefaultNav = document.querySelectorAll('a[is="simple-menu-item"]');
allDefaultNav.forEach((ele) => {
  new DefaultNavItem(ele);
});

/**
* background Overlay
*/
class siteOverlay extends HTMLElement{
  constructor() {
    super();

    this.menuDrawer = document.querySelector('#mobile-menu-drawer');
    this.cartDrawer = document.querySelector('#ajax-cart');
    this.searchDrawer = document.querySelector('search-modal');
    this.filterDrawer = document.querySelector('#collectionFilters');

    this.bindEvents();
  }

  connectedCallback() {
    
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   * @param {event} Event instance performed
   */
  onClick(event){
    const closeCart = this.cartDrawer && this.cartDrawer.classList.contains("opened-drawer");
    const closeMenu = this.menuDrawer && this.menuDrawer.classList.contains("opened-drawer");
    const closeSearch = this.searchDrawer && this.searchDrawer.classList.contains("open__modal");
    const closeFilter = this.filterDrawer && this.filterDrawer.classList.contains("filter-active");
    
    if(closeCart) document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    if(closeMenu) document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
    if(closeSearch) document.querySelector('.search-modal__close-button').dispatchEvent(new Event('click'));
    if(closeFilter) document.querySelector('[data-closedrawer]').dispatchEvent(new Event('click'));
  
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    document.querySelector('#site-overlay').classList.add('open');
    document.body.classList.add('scroll-fixed');
    setTimeout(() =>{
      document.querySelector('#site-overlay').classList.add('overlay--body');
    }, 100);
  }

  /**
   * Hide overlay 
   */
  hideOverlay(){
    document.querySelector('#site-overlay').classList.remove('overlay--body');
    document.body.classList.remove('scroll-fixed');
    setTimeout(() =>{
      document.querySelector('#site-overlay').classList.remove('open');
    }, 300);
  }
}
customElements.define("site-overlay", siteOverlay, {
  once: true
});

/**
 * Slider Component
 *
 */
 class sliderElement extends HTMLElement{
  constructor() {
    super();
    this.sliderEle = this.querySelector('.swiper-slider');
    this.sliderOptions = JSON.parse(this.sliderEle.getAttribute('data-slider'));
  }

  static get observedAttributes() {
    return ["data-slider"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-slider" && newValue) {
      this.sliderOptions = JSON.parse(newValue);
    }
  }

  connectedCallback() {
    if(!this.sliderEle) return;
    
    let thumbSlider = null;

    // Set up nav slider 
    if(this.sliderEle.hasAttribute('data-nav')){
      thumbSlider = document.querySelector(`.${this.sliderEle.getAttribute('data-nav')}`);
      if(!thumbSlider){
        return;
      }

      const thumbSliderOptions = JSON.parse(thumbSlider.getAttribute('data-slider'));
      thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);
      
      this.sliderOptions.thumbs = {
        swiper: thumbSlider
      }
    }

    const sliderInstance = new Swiper(this.sliderEle, this.sliderOptions);

    if(this.sliderEle.classList.contains('product-carousel')){
      productSlider = sliderInstance;
    }else if(this.sliderEle.classList.contains('quickshop-slider')){
      quickShopSlider = sliderInstance;
    }

    this.slideChangeEvt(sliderInstance, thumbSlider);
  }

  slideChangeEvt(slider, thumbSlider){   
    slider.on('slideChange', (event) => {
      if(thumbSlider) thumbSlider.slideTo(slider.activeIndex);

      const activeVideos = slider.el.querySelectorAll(
        ".custom-video-container.playing--video"
      );

      if(activeVideos.length > 0){        
        activeVideos.forEach((container)=>{
          let video = container.querySelector('custom-video');
          let videoType = video.getAttribute('data-video-type');
          let videoEle = video.querySelector('video') || video.querySelector('iframe');
          if(videoType == 'local'){
            videoEle.pause();
          }else if(videoType == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        });
      }
    });
  }
 }
 let lookForSwiper = setInterval(() => {
  if(typeof Swiper == 'function'){
    customElements.define('slider-element', sliderElement);
    clearInterval(lookForSwiper);
  } 
}, 100);

/**
* Custom Video
*/
class customVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';

    this.container = this.closest('.custom-video-container');
   // console.log(this);
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.container.querySelector('[data-trigger-video]');

    this.bindEvents();
  }

  connectedCallback() {
    // Connected callback
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(_event){
    let isOpen = this.container.classList.contains('playing--video');
    if(isOpen){
      this.container.classList.remove('playing--video');
    }else{
      if(this.videoStatus == 'empty' || this.placementType == 'popup'){
        const videoElement = this._buildVideo();
        videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
        this.videoSection.appendChild(videoElement);
        this.videoStatus = 'loaded';
        this.container.classList.add('playing--video');
        setTimeout(() => {
          (this.placementType == 'popup') ? openModal(this.videoModal, this.triggerVideo) : this.container.classList.add('playing--video');
          this.pauseOnVisibilityChange(videoElement);
          this._playVideo(videoElement);
        }, 700);        
      }else{
        const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
        this.container.classList.add('playing--video');
        this._playVideo(videoElement);
      }
    }
  }

  _playVideo(video){
    if(this.type == 'local' || this.type == 'unknown'){
      video.play();
    }else if(this.type == 'youtube'){
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local' || this.type == 'unknown' ){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      if(this.dataset.autoplay == 'true') video.autoplay = this.dataset.autoplay;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'vimeo'){
      let videoID = this.videoURL;
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", videoID  );
    }else if(this.type == 'youtube'){
      let videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", "https://www.youtube.com/embed/"+ videoID +`?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&muted=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}&enablejsapi=1&origin=${window.origin}` );
    }
    //console.log("video",video);
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    let scrollObserver = new IntersectionObserver((entries) => { 
      if(((this.type == 'local' || this.type == 'unknown' ) && videoEle == undefined) || (this.type == 'youtube' && videoEle.contentWindow == null)){
        scrollObserver.disconnect();
        return;
      }

      entries.forEach(entry => {
        if(entry.intersectionRatio == 0){
          if(this.type == 'local' || this.type == 'unknown'){
            videoEle.pause();
          }else if(this.type == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        }
      });
    });
    scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    let posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo || posterVideo == undefined) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          let sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();         
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }
}
customElements.define("custom-video", customVideo);

/**
  * Open Modal javscript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
    this.closeBtn = this.querySelector('[id^="ModalClose-"]');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if(this.closeBtn){
      this.closeBtn.addEventListener(
        'click',
        this.hide.bind(this)
      );
    }

    this.addEventListener('click', (evt) => {
      /** if (evt.target.nodeName === 'MODAL-DIALOG') this.hide(); **/
      if (!evt.target.closest('.modal-content')) this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    siteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    siteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
    if(document.querySelector('.custom-video-container.playing--video')){
      document.querySelector('.custom-video-container.playing--video').classList.remove('playing--video');
    }
    if(this.id == 'PopupModal-video'){
      this.querySelector('.video-container').innerHTML = '';

    }
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class Notification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
    this.animateNotifcation = null;
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  /**
   * Notification Type
   * @param title 
   * @param body 
   * @param options 
   */
  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.add('open', `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    cancelAnimationFrame(this.animateNotifcation);
    this.container.className = 'snotifyToast';
    [this.querySelector('.snotifyToast__title'),this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", Notification);
window.notificationEle = document.querySelector('toast-notification');
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 5000
// });